var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-ad-view"},[_c('div',{staticClass:"category-ad-group"},[(_vm.$isLogin())?_c('div',[_c('van-image',{staticClass:"category-ad-img",attrs:{"src":"https://m.a383.com/Img/Banner/hogaming_banner1.gif"},on:{"click":_vm.toHoGaming}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }